import { Component, Input, OnInit } from '@angular/core';
import { Item, Menu, SectionMenu } from '../../models/menu.model';
import { MenuService } from '../../services/menu.service';

@Component({
    selector: 'app-item-simple-list',
    templateUrl: './item-simple-list.component.html',
    styleUrls: ['./item-simple-list.component.scss'],
    standalone: false
})
export class ItemSimpleListComponent implements OnInit {
  /**
   * Informacion del menu seleccionado
   */
  @Input() menu: Menu = {} as Menu;
  /**
   * Listado de productos
   */
  @Input() section: SectionMenu = {} as SectionMenu;
  /**
   * Indica el idioma seleccionado
   */
  language: string | undefined;
  constructor(
    private menuService: MenuService
  ) { }

  ngOnInit(): void {
    this.menuService.language$.subscribe((lang: string) => {
      this.language = lang;
    });
  }

  clickName(item: Item): void {
    this.menuService.sendAnalyticsInfo(item, this.menu.departament, 'product_click');
  }

}

